module.exports = __webpack_public_path__ + "static/media/aw3.810a8a13.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_139/images/aw3.png
// module id = 1367
// module chunks = 0